import { forwardRef, useImperativeHandle, useRef } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useTheme } from "@/shared/hooks/useTheme";
import { P } from "@/shared/ui/typographies/paragraph";

export type CaptchaFieldHandle = { reset: () => void };

type CaptchaFieldProps = {
  sitekey: string
  onVerify: (token: string) => void
  /** hCaptcha tokens live ~2 minutes; without this the form submits a dead token. */
  onExpire?: () => void
  errorMessage?: string
};

export const CaptchaField = forwardRef<CaptchaFieldHandle, CaptchaFieldProps>(
  ({
    sitekey, onVerify, onExpire, errorMessage,
  }, ref) => {
    const captchaRef = useRef<HCaptcha>(null);
    const { theme } = useTheme();

    useImperativeHandle(ref, () => ({ reset: () => captchaRef.current?.resetCaptcha() }));

    return (
      <div className="space-y-1">
        <HCaptcha
          data-testid="captcha-input"
          ref={captchaRef}
          sitekey={sitekey}
          onVerify={(token) => onVerify(token)}
          onExpire={onExpire}
          theme={theme}
        />

        {errorMessage && (
          <P
            color="error"
            className="mt-1 text-sm break-words hyphens-auto max-w-full text-red-500"
          >
            {errorMessage}
          </P>
        )}
      </div>
    );
  },
);

CaptchaField.displayName = "CaptchaField";
